// @ts-nocheck
import {
    chain,
    SetCartStatus as baseSetCartStatus,
    DispatchCompletePlaceOrder as baseDispatchCompletePlaceOrder,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import cloneDeep from "lodash/cloneDeep";

export const SetCartStatus = createChainHandler("SetCartStatus", chain, props => {
    const state = props.getState();
    const { cartId, additionalEmails, editedCartNotes } = state.pages.onePageCheckout;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const newStatus = props.parameter?.isPending ? "PendingPaymentValidation" : "Submitted"; // Store Custom Code

    const notes = editedCartNotes === undefined || editedCartNotes === "" ? cart.notes : editedCartNotes; // Store Custom Code

    props.cartToUpdate = {
        ...cloneDeep(cart),
        status: newStatus,
        poNumber: props.parameter.poNumber,
        customerVatNumber: props.parameter.vatNumber || "",
        notes,
        additionalEmails: additionalEmails === undefined ? cart.additionalEmails : additionalEmails,
    };
});

replaceInChain(chain, baseSetCartStatus, SetCartStatus);

export const DispatchCompletePlaceOrder = createChainHandler("DispatchCompletePlaceOrder", chain, props => {
    props.dispatch({
        type: "Pages/OnePageCheckout/CompletePlaceOrder",
    });
    /* Store Custom Code - Start */
    props.dispatch({
        type: "Pages/OnePageCheckout/SetNotes",
        notes: "",
    });
    /* Store Custom Code - End */
});

replaceInChain(chain, baseDispatchCompletePlaceOrder, DispatchCompletePlaceOrder);
